export default __webpack_public_path__ + "static/media/bgHome.ca7d7b3b.png";